import React, { Component } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import NeedHelp from '../Elements/NeedHelp';
import YtTabs from './ytTabs';
import { getInitialRoute } from '../../../../../../utils';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import { createFeedAction } from '../../../../../../actions/addFeedActions';


class Youtube extends Component {
    state = {
        textField: "",
        shorts: "",
        playList: "",
        keyword: "",
        location: "",
        locationKeyword: "",
        manuallyApprove: false,
        error: false,
        shortError: false,
        playListError: false,
        keywordError: false,
        locationError: false,
        locationKeywordError: false,
        filterType: "Channel Url",
        channelId: "",
        shortId: "",
        playlistId: "",
        latlng: null,
        isLoading: false,
        errorMsg: null
    }

    componentDidMount() {
        this.props.onFilterNameChange(this.state.filterType)
    }

    onTextFieldChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, shortError: false, keywordError: false, playListError: false, keywordError: false})

    onManuallyApproveChange = (value) => this.setState({ manuallyApprove: value })
    onLatlanChange = (value) => this.setState({ latlng: value,locationError:false,errorMsg:null });
    onLocationValueChange = (value) => this.setState({ location: value });
    onChannelIdChange = (value,tab) => {
        if (tab == 'Channel Url') {
            this.setState({ channelId: value })
        } else if (tab == 'Shorts') {
            this.setState({ shortId: value })
        } else if (tab == 'Play List') {
            this.setState({ playlistId: value })
        }
    }
    onTextValueChange = (tab, value) => {
        if (tab == 'Channel Url') {
            this.setState({ textField: value, error: false, errorMsg: null });
        } else if (tab == 'Shorts') {
            this.setState({ shorts: value, shortError: false, errorMsg: null });
        } else if (tab == 'Play List') {
            this.setState({ playList: value, playListError: false, errorMsg: null });
        } else if (tab == 'Keywords') {
            this.setState({ keyword: value, keywordError: false, errorMsg: null });
        } else if (tab == 'Location') {
            this.setState({ location: value, locationError: false, errorMsg: null, latlng: null });
        }
    }
    onSubmit = () => {
        const { textField, manuallyApprove, keyword, shorts, playList, filterType, channelId,shortId,playlistId, latlng, location, locationKeyword } = this.state
        const { feedInfo, hideAddfeed, navigation, wallId } = this.props;

        const ftr = feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.findIndex(f => f.feedtype == filterType) : null
        const selectedFilterId = feedInfo[0]?.networkTab[ftr]?.filter;

        if (selectedFilterId == 1 && textField == "") {
            this.setState({ error: true, errorMsg:null })
        } else if (selectedFilterId == 75 && shorts == '') {
            this.setState({ shortError: true, errorMsg:null })
        } else if (selectedFilterId == 11 && playList == '') {
            this.setState({ playListError: true, errorMsg:null })
        } else if (selectedFilterId == 4 && keyword == '') {
            this.setState({ keywordError: true, errorMsg:null })
        } else if (selectedFilterId == 32 && location == '') {
            this.setState({ locationError: true, errorMsg:null })
        } else if (selectedFilterId == 32 && latlng == null) {
            this.setState({ locationError: true, errorMsg: "Please select from dropdown" })
        } else if (selectedFilterId == 32 && locationKeyword == '') {
            this.setState({ locationKeywordError: true })
        }
        else {

            var obj = {
                wallId: wallId,
                networkId: 7,
                filter: selectedFilterId,
                moderation: manuallyApprove ? 1 : 0,
                channelId: "",
            }
            if (selectedFilterId == 1) {
                obj['feedText'] = textField;
                obj['channelId'] = channelId;
            } else if (selectedFilterId == 75) {
                obj['feedText'] = shorts;
                obj['channelId'] = shortId;
            } else if (selectedFilterId == 11) {
                obj['feedText'] = playList;
                obj['channelId'] = playlistId;
            } else if (selectedFilterId == 4) {
                obj['feedText'] = keyword;
            } else if (selectedFilterId == 32) {
                obj['feedText'] = location;
            }
            if (selectedFilterId == 32) obj = { ...obj, keywords: locationKeyword, latlng };
            

            this.setState({ isLoading: true, error: false, shortError: false, keywordError: false, playListError: false, keywordError: false });

            createFeedAction(obj, 7, (feedId) => this.setState({ isLoading: false }, () => {
                if (feedId) {
                    hideAddfeed();
                    navigation(`/moderation/index/${wallId}`);
                }
            }))
        }
    }

    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'Channel Url':
                    return ['https://vimeo.com/715482617', 'https://taggbox.com/support/how-to-embed-youtube-channel-on-website/']
                case 'Shorts':
                    return ['https://vimeo.com/699750432/09ddb2a985', 'https://taggbox.com/support/how-to-embed-youtube-shorts-on-websites/']
                case 'Play List':
                    return ['https://player.vimeo.com/video/497245578', 'https://taggbox.com/support/embed-youtube-video-website/']
                case 'Keywords':
                    return ['https://vimeo.com/715482628', 'https://taggbox.com/support/embed-youtube-video-website/']
                case 'Location':
                    return ['https://player.vimeo.com/video/497245578', 'https://taggbox.com/support/embed-youtube-video-website/']
                default:
                    return ['https://vimeo.com/715482617', 'https://taggbox.com/support/how-to-embed-youtube-channel-on-website/']
            }
        } else {
            switch (filterType) {
                case 'Channel Url':
                    return ['https://vimeo.com/537137051/dc6c1b6b99', '']
                case 'Shorts':
                    return ['https://player.vimeo.com/video/497245578', '']
                case 'Play List':
                    return ['https://vimeo.com/537137051/dc6c1b6b99', '']
                case 'Keywords':
                    return ['https://vimeo.com/540127562/28cb9bb734', '']
                case 'Location':
                    return ['https://vimeo.com/540128876/b58953ad5c', '']
                default:
                    return ['https://vimeo.com/537137051/dc6c1b6b99', '']
            }
        }
    }

    render() {
        const { textField, shorts, playList, location, manuallyApprove, errorMsg, keyword, locationKeyword, shortError, playListError, locationError, error, channelId, isLoading, locationKeywordError, keywordError, filterType } = this.state
        const { feedInfo } = this.props;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body create_feed_wt">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            <Tabs defaultActiveKey="Channel Url" id="YoutubeFeedTab" onSelect={e => this.setState({ filterType: e,error: false,shortError: false,playListError: false,keywordError: false,locationError: false }, () => this.props.onFilterNameChange(e))} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                                {feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.map(filter =>
                                    <Tab eventKey={filter.feedtype} key={filter.filter} className="nav-link p-0" title={<span>{filter.feedName}</span>}>
                                        <YtTabs tab={filter.feedtype}
                                            error={filter.filter == 1 ? error : filter.filter == 75 ? shortError : filter.filter == 11 ? playListError : filter.filter == 4 ? keywordError : filter.filter == 32 ? locationError : error}
                                            value={filter.filter == 1 ? textField : filter.filter == 75 ? shorts : filter.filter == 11 ? playList : filter.filter == 4 ? keyword : filter.filter == 32 ? location : textField}
                                            onLatlanChange={this.onLatlanChange}
                                            onValueChange={this.onTextFieldChange}
                                            onCheckBoxChange={this.onManuallyApproveChange}
                                            onChannelIdChange={this.onChannelIdChange}
                                            onTextValueChange={this.onTextValueChange}
                                            onLocationValueChange={this.onLocationValueChange}
                                            checkBox={manuallyApprove}
                                            channelId={channelId}
                                            locationKeyword={locationKeyword}
                                            locationKeywordError={locationKeywordError}
                                            errorMsg={errorMsg}
                                        />
                                    </Tab>
                                ) : null}
                            </Tabs>
                            <div className="form-actions w-100">
                                <div className="f-between flex-wrap border-top pt-3 mt-4">
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                                    <SubmitFeedRequest onSubmit={this.onSubmit} onBack={this.props.onBack} loading={isLoading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Youtube;
